export default {
    name: 'logistique-dashboard',
    data() {
        return { loading: false, error: '' }
    },
    computed: {
        stocks() {
            const stocks = this.$store.getters['stocks']
            return Array.isArray(stocks) ? stocks : []
        },
        espaces() {
            const predefined = [
                { code: 'magasin-central', nom: 'Magasin central', description: 'Réceptionner et répartir les livraisons.', icon: 'fa-warehouse' },
                { code: 'pharmacie', nom: 'Pharmacie', description: 'Suivre les médicaments et les consommables.', icon: 'fa-capsules' },
                { code: 'laboratoire', nom: 'Laboratoire', description: 'Suivre les réactifs et le matériel de prélèvement.', icon: 'fa-flask' },
                { code: 'entretien', nom: 'Entretien', description: 'Suivre les fournitures et produits d’entretien.', icon: 'fa-pump-soap' }
            ].map(espace => {
                const stock = this.stocks.find(item => item.code === espace.code)
                return { ...espace, id: stock ? stock.id : null, url: stock ? '/stock/show/' + stock.id : null }
            })
            const knownCodes = new Set(predefined.map(espace => espace.code))
            const additional = this.stocks.filter(stock => !knownCodes.has(stock.code)).map(stock => ({
                id: stock.id,
                code: stock.code,
                key: 'stock-' + stock.id,
                nom: stock.nom,
                description: stock.description || 'Consulter les articles et les mouvements de cet emplacement.',
                icon: 'fa-boxes',
                url: '/stock/show/' + stock.id
            }))
            return predefined.concat(additional)
        }
    },
    mounted() {
        this.loadSpaces()
    },
    methods: {
        chooseSpace(espace) {
            this.$store.dispatch('selectStockSpace', espace)
        },
        loadSpaces() {
            this.error = ''
            this.loading = true
            return this.$store.dispatch('getStocks')
                .catch(error => {
                    const status = Number(error && error.response && error.response.status)
                    if (status && status < 500) throw error
                    return new Promise(resolve => setTimeout(resolve, 250))
                        .then(() => this.$store.dispatch('getStocks'))
                })
                .catch(() => { this.error = 'Impossible de charger les espaces de stock. Réessayez.' })
                .finally(() => { this.loading = false })
        },
        reload() {
            return this.loadSpaces()
        }
    }
}
